import { useCallback } from 'react';
import { trackUsage } from '../deferred/analytics/NavUsageTrackers';
import getCurrentApp from '../utils/getCurrentApp';
import getCurrentUrlWithoutPortalId from '../utils/getCurrentUrlWithoutPortalId';
import getDataAttr from '../utils/getDataAttr';
import { getNavInteractionStartTime } from '../utils/navInteractionStartTime';
import useIsVerticalNavPinned from './useIsVerticalNavPinned';
import { ONE_SECOND } from '../constants/time';
import { useAppSelector } from '.';
import { selectIADetails } from '../selectors/iaDetails.selectors';
const useUsageTracker = () => {
  const expanded = useIsVerticalNavPinned();
  const {
    iaName
  } = useAppSelector(selectIADetails);
  const track = (type, properties) => {
    trackUsage(type, properties);
  };
  const trackNavClick = event => {
    if (!event.currentTarget || !(event.currentTarget instanceof HTMLElement)) {
      return;
    }
    const currentUrl = getCurrentUrlWithoutPortalId();
    const destinationUrl = event.currentTarget.hasAttribute('href') ? event.currentTarget.getAttribute('href').replace(/[0-9]/g, '') : '';
    const countDisplayed = getDataAttr('notificationsButtonCountBadge', event.currentTarget);
    const level = getDataAttr('menuItemLevel', event.currentTarget);
    const navInteractionStartTime = getNavInteractionStartTime();
    const ellapsedNavInteractionTime = navInteractionStartTime ? +((performance.now() - navInteractionStartTime) / ONE_SECOND).toFixed(2) // restrict to a max of 2 decimal places
    : 0;
    const payload = {
      currentUrl,
      destinationUrl,
      currentApp: getCurrentApp(),
      isNewNav: true,
      level,
      target: event.currentTarget.id,
      navGroup: getDataAttr('menuItemGroup', event.currentTarget),
      tourStep: getDataAttr('onboardingCurrentStep', event.currentTarget),
      action: getDataAttr('clickAction', event.currentTarget),
      numOfShortcuts: getDataAttr('shortcutCount', event.currentTarget),
      countDisplayed,
      discoveryTime: (level === 'secondary' || level === 'tertiary') && ellapsedNavInteractionTime > 0 ? ellapsedNavInteractionTime : undefined,
      expanded,
      iaVersion: iaName
    };
    track('navClickEvent', payload);
  };
  const trackSearchEvent = useCallback(properties => {
    trackUsage('navSearchInteraction', properties);
  }, []);
  return {
    trackNavClick,
    track,
    trackSearchEvent
  };
};
export default useUsageTracker;